import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from "react-redux";
import {compose} from "recompose";
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui';
import ProductUnitStaticTableRow from '../components/ProductUnitStaticTableRow';

/**
 * A component for generating rows of ProductUnitStaticTableRows.
 *
 */
class ProductUnitStaticTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productId: '',
            productType: '',
            productUnitList: {},
            noProductUnits: false,
        };
    }

    componentWillMount() {
        this.setState({
            productId: this.props.productId,
            productType: this.props.productType,
        });
        this.fetchProductUnits();
    }

    // Get all Product Units for this Product
    fetchProductUnits() {
        const params = {
            filter: {
                type: this.props.productType,
                id: this.props.productId
            },
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.ProductUnitsByTypeProductId.GET_LIST(params);

        // Retrieve the data and store results
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        this.setState({
                            productUnitList: result.data.payload,
                            noProductUnits: false
                        });
                    } else {
                        this.setState({
                            noProductUnits: true
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    // Create table rows of Product Unit items
    makeProductUnitStaticTable = (list, id, type, path, showView, showEdit, showDelete) => {
        const styles = {
            row: {height: '35px',},
            column: {height: '35px'},
            columnFirst: {paddingLeft: '36px'},
        };

        if (!list || !list.length) {
            let message = (this.state.noProductUnits) ? 'No Product Units' : 'Loading';
            return (
                [<TableRow key={`product-unit-empty-${id}-${type}`} style={styles.row}>
                    <TableRowColumn
                        colSpan={4}
                        style={{...styles.column, ...styles.columnFirst}}>
                        {message}
                    </TableRowColumn>
                    {showView &&
                    <TableRowColumn style={styles.column}>&nbsp;</TableRowColumn>
                    }
                    {showEdit &&
                    <TableRowColumn style={styles.column}>&nbsp;</TableRowColumn>
                    }
                    {showDelete &&
                    <TableRowColumn style={styles.column}>&nbsp;</TableRowColumn>
                    }
                </TableRow>]
            )
        }
        return (
            list.map((item, index) => (
                <ProductUnitStaticTableRow
                    key={item.id.toString() + index}
                    data={item}
                    productUnitPath={path}
                    showView={showView}
                    showEdit={showEdit}
                    showDelete={showDelete}
                />
            ))
        )
    };

    render() {
        const {
            productId,
            productType,
            productUnitPath,
            showCreate,
            showDelete,
            showEdit,
            showView,
        } = this.props;

        const styles = {
            bg: {backgroundColor: '#f6f6f6'},
            row: {height: '35px',},
            column: {height: '35px'},
            columnFirst: {paddingLeft: '36px'},
            create: {
                backgroundColor: '#f6f6f6',
                textAlign: 'right',
                paddingRight: '36px',
                borderBottom: '1px solid rgb(244,244,244)'
            },
        };

        return (
            <div>
                <Table selectable={false} multiSelectable={false} style={styles.bg}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow style={styles.row}>
                            <TableHeaderColumn
                                style={{...styles.column, ...styles.columnFirst}}>Barcode</TableHeaderColumn>
                            <TableHeaderColumn style={styles.column}>Name</TableHeaderColumn>
                            <TableHeaderColumn style={styles.column}>Unit Type</TableHeaderColumn>
                            <TableHeaderColumn style={styles.column}>Price</TableHeaderColumn>
                            {showView &&
                            <TableHeaderColumn style={styles.column}>View</TableHeaderColumn>
                            }
                            {showEdit &&
                            <TableHeaderColumn style={styles.column}>Edit</TableHeaderColumn>
                            }
                            {showDelete &&
                            <TableHeaderColumn style={styles.column}>Delete</TableHeaderColumn>
                            }
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false} style={styles.bg}>
                        {[...this.makeProductUnitStaticTable(this.state.productUnitList, productId, productType, productUnitPath, showView, showEdit, showDelete)]}
                    </TableBody>
                </Table>

                {showCreate &&
                <div style={styles.create}>
                    <FlatButton
                        primary
                        label={`Add a Product Unit for ${productId}`}
                        icon={<ContentAdd/>}
                        containerElement={<Link to={`${productUnitPath}/${productType}/${productId}/create`}/>}
                    />
                </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        return {
            productId: ownProps.productId,
            productType: ownProps.productType,
            productUnitList: ownProps.productUnitList,
            productView: ownProps.productView,
        }
    }
    return {}
};

ProductUnitStaticTable.propTypes = {
    addField: PropTypes.bool,
    productId: PropTypes.string,
    productType: PropTypes.string,
    productUnitList: PropTypes.object,
    productUnitPath: PropTypes.string,
    productView: PropTypes.string,
    showCreate: PropTypes.bool,
    showDelete: PropTypes.bool,
    showEdit: PropTypes.bool,
    showView: PropTypes.bool,
};

ProductUnitStaticTable.defaultProps = {
    addField: true,
    productId: null,
    productType: null,
    productUnitList: {},
    productUnitPath: '/ProductUnits',
    productView: 'list',
    showCreate: false,
    showDelete: false,
    showEdit: false,
    showView: false,
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(ProductUnitStaticTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductUnitStaticTable.js